
import Home from './Home/Home';
import AllTools from './AllTools/AllTools';
import Main from './Main/Main';
import Splash from './Splash/Splash';
import Login from './Login/Login';
import Fallback from './Login/Fallback';
import PrivacyPolicy from './PrivacyPolicy/PrivacyPolicy';
import CropImage from './image/CropImage/CropImage';
import RotateImage from './image/RotateImage/RotateImage';
import Base64 from './image/Base64/Base64';
import Compression from './image/Compression/Compression';
import Conversion from './image/Conversion/Conversion';
import Resizing from './image/Resizing/Resizing';
import ImageFilters from './image/ImageFilters/ImageFilters';
import Watermark from './image/Watermark/Watermark';
import ImageMerger from './image/ImageMerger/ImageMerger';
import BackgroundTools from './image/BackgroundTools/BackgroundTools';
import ColorPalette from './image/ColorPalette/ColorPalette';
import TermsOfUse from './TermsOfUse/TermsOfUse';
import RotatePDF from './pdf/RotatePDF/RotatePDF';
import ReorderPDF from './pdf/ReorderPDF/ReorderPDF';
import ImagesToPDF from './pdf/ImagesToPDF/ImagesToPDF';
import SplitPDF from './pdf/SplitPDF/SplitPDF';
import WatermarkPDF from './pdf/WatermarkPDF/WatermarkPDF';
import EditMetadata from './pdf/EditMetadata/EditMetadata';
import MergePDF from './pdf/MergePDF/MergePDF';
import AboutUs from './About/About';
import ContactUs from './Contact/Contact';
import Blog from './Blog/Blog';
import BlogPost from './Blog/BlogPost';
import ToolCard from '../shared/ToolCard/ToolCard';

export default {
    Main,
    Home,
    AllTools,
    Splash,
    Login,
    Fallback,
    PrivacyPolicy,
    CropImage,
    RotateImage,
    Base64,
    Compression,
    Conversion,
    Resizing,
    ImageFilters,
    Watermark,
    ImageMerger,
    BackgroundTools,
    ColorPalette,
    TermsOfUse,
    RotatePDF,
    ReorderPDF,
    ImagesToPDF,
    SplitPDF,
    WatermarkPDF,
    EditMetadata,
    MergePDF,
    AboutUs,
    ContactUs,
    Blog,
    BlogPost,
    ToolCard
}